import React from 'react'

interface Error {
  metadata: {
    row: any
  }
  field_id: string
}

interface MoveToCellArgs {
  tableRef: React.RefObject<any>
  binderRef: React.RefObject<any>
  errors: Error[]
}

/**
 * Each time this function is triggered, we move the selected cell to the next
 * cell with an error.
 * @param params
 * @param tableRef React Ref of the table HOT instance.
 * @param tableRef React Ref of the HOT binder instance.
 * @param errors An array of error objects.
 */
export function moveToCellWithError({ tableRef, binderRef, errors }: MoveToCellArgs) {
  const countColumns = tableRef.current?.countCols()
  const [startRow, startCol] = tableRef.current?.getSelectedLast() || [] // Fallback to empty array or get Iterable is not defined error.
  const invalidCells = errors

  invalidCells.sort((a, b) =>
    a.metadata.row * countColumns + binderRef.current?.visibleRenderColumnsOrderById[a.field_id] <
    b.metadata.row * countColumns + binderRef.current?.visibleRenderColumnsOrderById[b.field_id]
      ? -1
      : 1,
  )

  const currentIdx = startRow * countColumns + startCol
  const nextCell = invalidCells.find(invalidCell => {
    const idxForCell =
      invalidCell.metadata.row * countColumns +
      binderRef.current?.visibleRenderColumnsOrderById[invalidCell.field_id]
    return idxForCell > currentIdx
  })
  const toSelect = nextCell ?? invalidCells[0]

  if (toSelect) {
    tableRef.current?.selectCell(
      toSelect.metadata.row,
      binderRef.current?.visibleRenderColumnsOrderById[toSelect.field_id],
    )
  }
}
